var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { ref: "formReceivers" }, [
    _c("div", { staticClass: "emd-panel" }, [
      _c("div", { staticClass: "emd-panel__section" }, [
        _c("div", { staticClass: "emd-panel__block" }, [
          _c("div", { staticClass: "el-chunk" }, [
            _c("h2", { staticClass: "emd-text _color_default _type_caption" }, [
              _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "emd-panel__block" }, [
          _c("div", { staticClass: "el-chunk" }, [
            _c("div", { staticClass: "emd-form-group" }, [
              _c(
                "label",
                { staticClass: "emd-label _required", attrs: { for: "name" } },
                [_vm._v(_vm._s(_vm.$t("name")))]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.name,
                    expression: "form.name",
                  },
                ],
                staticClass: "emd-input",
                class: {
                  _state_error:
                    _vm.$v.form.name.$invalid && _vm.$v.form.name.$dirty,
                },
                attrs: {
                  disabled: _vm.disabled,
                  id: "name",
                  "data-testid": "name",
                },
                domProps: { value: _vm.form.name },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "name", $event.target.value)
                    },
                    _vm.$v.form.name.$touch,
                  ],
                },
              }),
            ]),
            _c("div", { staticClass: "emd-form-group" }, [
              _c(
                "label",
                { staticClass: "emd-label _required", attrs: { for: "email" } },
                [_vm._v(_vm._s(_vm.$t("email")))]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.email,
                    expression: "form.email",
                  },
                ],
                staticClass: "emd-input",
                class: {
                  _state_error:
                    _vm.$v.form.email.$invalid && _vm.$v.form.email.$dirty,
                },
                attrs: {
                  disabled: _vm.disabled,
                  id: "email",
                  "data-testid": "email",
                },
                domProps: { value: _vm.form.email },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "email", $event.target.value)
                    },
                    _vm.$v.form.email.$touch,
                  ],
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "emd-form-group" },
              [
                _c(
                  "label",
                  {
                    staticClass: "emd-label _required",
                    attrs: { for: "phone" },
                  },
                  [_vm._v(_vm._s(_vm.$t("phone")))]
                ),
                _c("the-mask", {
                  staticClass: "emd-input",
                  class: {
                    _state_error:
                      _vm.$v.form.phone.$invalid && _vm.$v.form.phone.$dirty,
                  },
                  attrs: {
                    disabled: _vm.disabled,
                    masked: false,
                    "data-testid": "phone",
                    mask: ["(##) ####-####", "(##) #####-####"],
                    type: "tel",
                  },
                  on: { input: _vm.$v.form.phone.$touch },
                  model: {
                    value: _vm.form.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "phone", $$v)
                    },
                    expression: "form.phone",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }